
import { Dialog } from 'element-ui';
Dialog.props.lockScroll.default = false;
export default {
  components: {
    ElDialog: Dialog,
  },
  props: {
    messageData: {
      type: Object,
      default() {
        return {
          show: false,
          content: '该内容已限制评论',
          titel: '温馨提示',
        };
      },
    },
  },
  data() {
    return {};
  },
  methods: {
    confirm() {
      this.$emit('confirm');
    },
  },
};
